module.exports = __webpack_public_path__ + "img/ícone-imagem-selecionada.b5bfd6ad.svg";